export const LOAD_ASSETS = "LOAD_ASSETS";
export const LOAD_ASSETS_SUCCESS = "LOAD_ASSETS_SUCCESS";
export const LOAD_ASSETS_ERROR = "LOAD_ASSETS_ERROR";
